import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

function EtOtherSummary() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [filteredData, setFilteredData] = useState([]);

  const sortByOrderNumber = (data) => {
    return data.sort((a, b) => b.OrderNumber.localeCompare(a.OrderNumber));
  };

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/unsoldEtItems`);
      const fetchedData = response.data.map((item) => ({
        ...item,
        imageUrl1: `${apiUrl}/uploads/${item.ImageFilename1}`, // Construct the first image URL
        imageUrl2: `${apiUrl}/uploads/${item.ImageFilename2}`, // Construct the image URL
      }));
      const sortedData = sortByOrderNumber(fetchedData);

      setFilteredData(sortedData); // Initialize filteredData with all products
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="items-center flex flex-col justify-center mt-5 overflow-auto">
      <h1 className="font-bold text-2xl my-3">ET Available Phones</h1>
      <table className="border-collapse table-auto w-full mb-10 overflow-x-scroll">
        <thead>
          <tr>
            <th className="border-b-1 pb-3 border-slate-600 text-left bg-gray-200">
              #
            </th>
            <th className="border-b-1 pb-3 border-slate-600 text-left bg-gray-300">
              Brand
            </th>
            <th className="border-b-1 pb-3 border-slate-600 text-left bg-gray-200">
              Model
            </th>
            <th className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-300">
              Storage
            </th>
            <th className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
              Ram
            </th>
            <th className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-300">
              Sim
            </th>
            <th className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
              Price
            </th>
            <th className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-300">
              Delivery Fee
            </th>
            <th className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
              Total Price
            </th>
            <th className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-300">
              ET Status
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((item, index) => {
            // Calculate total price for the current row
            const totalPriceForRow = () => {
              const price = Number(item.Price) || 0;
              const com1 = Number(item.com1) || 70;
              const com2 = Number(item.com2) || 40;
              const deliveryFee = Number(item.DeliveryFee) || 0;
              return price + com1 + com2 + deliveryFee;
            };

            return (
              <tr key={index}>
                <td className="border-b-1 pb-3 border-slate-600 text-left font-bold text-slate-800 m-0 bg-gray-100">
                  {item.OrderNumber}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                  {item.Brand}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                  {item.Model}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                  {item.Storage}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                  {item.Ram}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                  {item.Sim}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                  {item.Price}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                  {item.DeliveryFee}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                  {totalPriceForRow()} {/* Show total for each row */}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                  {item.ourStat}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="flex flex-row">
        <h1 className="text-2xl font-bold mr-2">Total Remaining: </h1>
        <p className="text-2xl underline"> {filteredData.length}</p>
      </div>
    </div>
  );
}

export default EtOtherSummary;
